<template>
  <div class="appHouseholdPortrait">
    <!-- <el-card style="margin-bottom: 20px;padding: 20px;">
      <div class="jump-btn">
        <div class="tag1">
          <el-tag :key="row.nickName" type="" effect="dark"
            style="margin-right:20px;margin-bottom:20px;height:50px;line-height:50px;font-size:18px;">
            业主姓名：{{row.nickName}}
          </el-tag>
          <el-tag :key="row.nickName" type="" effect="dark"
            style="margin-right:20px;margin-bottom:20px;height:50px;line-height:50px;font-size:18px;">
            业主电话：{{row.mobile}}
          </el-tag>
          <el-tag :key="row.nickName" type="" effect="dark"
            style="margin-right:20px;margin-bottom:20px;height:50px;line-height:50px;font-size:18px;">
            业主房间信息：{{row.garden.name}}-{{row.garden.grids.houseName}}-{{row.garden.grids.unitName}}-{{row.garden.grids.roomName}}
          </el-tag>
        </div>
        <el-button type="primary" @click="jump">返回APP住户管理</el-button>
      </div>
    </el-card> -->
    <el-card>
      <div class="jump-btn" style="margin-bottom:50px;">
        <!-- <el-button class="tag1" type='primary' @click="tabNum=1">按业主选</el-button>
        <el-button class="tag2" type='warning' @click="tabNum=2">按房间选</el-button> -->
        <div class="tag1">
          <el-tag type="" effect="dark"
            style="margin-right:20px;margin-bottom:20px;height:50px;line-height:50px;font-size:18px;">
            业主姓名：{{row.nickName}}
          </el-tag>
          <el-tag type="" effect="dark"
            style="margin-right:20px;margin-bottom:20px;height:50px;line-height:50px;font-size:18px;">
            业主电话：{{row.mobile}}
          </el-tag>
          <el-tag type="" effect="dark"
            style="margin-right:20px;margin-bottom:20px;height:50px;line-height:50px;font-size:18px;">
            业主房间信息：{{row.garden.name}}-{{row.garden.grids.houseName}}-{{row.garden.grids.unitName}}-{{row.garden.grids.roomName}}
          </el-tag>
        </div>
        <el-button type="primary" @click="jump">返回APP住户管理</el-button>
      </div>
      <div class="cardList">
        <div class="lineBox1">
          <!-- 报事总数 -->
          <el-card class="box-card">
            <div @click="getDrawMaintains1(1)">
              <p class="cardTitle">报事总数</p>
              <div class="cardCont">
                <img class="cardImg" src="../../../assets/imgs/icon_card01.png" />
                <p class="cardInfo">{{drawRoomInfo.maintainCount}}</p>
              </div>
            </div>
          </el-card>
          <!-- 投诉总数 -->
          <el-card class="box-card">
            <div @click="getDrawMaintains1(2)">
              <p class="cardTitle">投诉总数</p>
              <div class="cardCont">
                <img class="cardImg" src="../../../assets/imgs/icon_card02.png" />
                <p class="cardInfo">{{drawInfo.complain}}</p>
              </div>
            </div>
          </el-card>
          <!-- 业主标签 -->
          <el-card class="box-card">
            <div @click="getDrawUser1(3)">
              <p class="cardTitle">业主标签</p>
              <div class="cardCont">
                <img class="cardImg" src="../../../assets/imgs/icon_card03.png" />
                <p class="cardInfo">{{drawInfo.userDrawCount}}</p>
              </div>
            </div>
          </el-card>
          <!-- 业主档案（附件） -->
          <el-card class="box-card">
            <div @click="getDrawFiles1(4)">
              <p class="cardTitle">业主档案</p>
              <div class="cardCont">
                <img class="cardImg" src="../../../assets/imgs/icon_card04.png" />
                <p class="cardInfo">{{drawInfo.fjCount}}</p>
              </div>
            </div>
          </el-card>
          <!-- 业主变更信息记录 -->
          <el-card class="box-card">
            <div @click="getDrawRoomOwnerChange1(5)">
              <p class="cardTitle">变更信息记录</p>
              <div class="cardCont">
                <img class="cardImg" src="../../../assets/imgs/icon_card05.png" />
                <p class="cardInfo">{{drawInfo.rcCount}}</p>
              </div>
            </div>
          </el-card>
          <!-- 业主开门记录 -->
          <el-card class="box-card">
            <div @click="getDrawDoorDeviceRecord1(6)">
              <p class="cardTitle">开门记录</p>
              <div class="cardCont">
                <img class="cardImg" :class="getSmallIcon(drawInfo.doorCount)" src="../../../assets/imgs/icon_card06.png" />
                <p class="cardInfo" :class="getSmallFont(drawInfo.doorCount)">{{drawInfo.doorCount}}</p>
              </div>
            </div>
          </el-card>
        </div>
        <div class="lineBox2">
          <!-- 业主乘梯记录 -->
          <el-card class="box-card">
            <div @click="getDrawLiftRecord1(7)">
              <p class="cardTitle">乘梯记录</p>
              <div class="cardCont">
                <img class="cardImg" :class="getSmallIcon(drawInfo.liftCount)" src="../../../assets/imgs/icon_card07.png" />
                <p class="cardInfo" :class="getSmallFont(drawInfo.liftCount)">{{drawInfo.liftCount}}</p>
              </div>
            </div>
          </el-card>
          <!-- 业主缴费信息 -->
          <el-card class="box-card">
            <div @click="getDrawPayFee1(8)">
              <p class="cardTitle">缴费信息(元)</p>
              <div class="cardCont">
                <img class="cardImg" :class="getSmallIcon(drawInfo.jfAmount)" src="../../../assets/imgs/icon_card08.png" />
                <p class="cardInfo" :class="getSmallFont(drawInfo.jfAmount)">{{drawInfo.jfAmount}}</p>
              </div>
            </div>
          </el-card>
          <!-- 业主车位信息 -->
          <el-card class="box-card">
            <!-- <div @click="getDrawCarPlaceCount1(9)"> -->
            <div>
              <p class="cardTitle">车位信息</p>
              <div class="cardCont">
                <img class="cardImg" src="../../../assets/imgs/icon_card09.png" />
                <p class="cardInfo">{{drawInfo.carPlaceCount}}</p>
              </div>
            </div>
          </el-card>
          <!-- 业主车辆信息 -->
          <el-card class="box-card">
            <div @click="getDrawCarNum1(10)">
              <p class="cardTitle">车辆信息</p>
              <div class="cardCont">
                <img class="cardImg" src="../../../assets/imgs/icon_card010.png" />
                <p class="cardInfo">{{drawInfo.carCount}}</p>
              </div>
            </div>
          </el-card>
          <!-- 居家服务金额 -->
          <el-card class="box-card">
            <div @click="getDrawMaintainPrice1(11)">
              <p class="cardTitle">居家服务金额(元)</p>
              <div class="cardCont">
                <img class="cardImg" :class="getSmallIcon(drawInfo.price)" src="../../../assets/imgs/icon_card011.png" />
                <p class="cardInfo" :class="getSmallFont(drawInfo.price)">{{drawInfo.price}}</p>
              </div>
            </div>
          </el-card>
          <!-- 商城消费金额，积分 -->
          <el-card class="box-card">
            <div @click="getDrawSklOrder1(12)">
              <p class="cardTitle">商城消费(元)</p>
              <div class="cardCont">
                <img class="cardImg" :class="getSmallIcon(drawInfo.sklOrderPrice)" src="../../../assets/imgs/icon_card012.png" />
                <p class="cardInfo" :class="getSmallFont(drawInfo.sklOrderPrice)">{{drawInfo.sklOrderPrice}}</p>
              </div>
            </div>
          </el-card>
        </div>
        <div class="lineBox3">
          <!-- 邻里帮发帖记录 -->
          <el-card class="box-card">
            <div @click="getDrawTopic1(13)">
              <p class="cardTitle">邻里帮发帖记录</p>
              <div class="cardCont">
                <img class="cardImg" src="../../../assets/imgs/icon_card013.png" />
                <p class="cardInfo">{{drawInfo.topicCount}}</p>
              </div>
            </div>
          </el-card>
          <!-- 代客报事 -->
          <el-card class="box-card">
            <div @click="getDrawValet1(17)">
              <p class="cardTitle">代客报事</p>
              <div class="cardCont">
                <img class="cardImg" src="../../../assets/imgs/icon_card017.png" />
                <p class="cardInfo">{{drawInfo.valetCount}}</p>
              </div>
            </div>
          </el-card>
          <!-- 沟通记录 -->
          <el-card class="box-card">
            <div @click="getDrawImage1(18)">
              <p class="cardTitle">沟通记录</p>
              <div class="cardCont">
                <img class="cardImg" src="../../../assets/imgs/icon_card018.png" />
                <p class="cardInfo">{{drawInfo.drawImageCount}}</p>
              </div>
            </div>
          </el-card>
          <!-- 格林房屋信息 -->
          <el-card class="box-card">
            <div @click="getDrawUserGarden1(14)">
              <p class="cardTitle">格林房屋信息</p>
              <div class="cardCont">
                <img class="cardImg" src="../../../assets/imgs/icon_card014.png" />
                <p class="cardInfo">{{drawInfo.roomCount}}</p>
              </div>
            </div>
          </el-card>
          <!-- 园区月度评价 -->
          <el-card class="box-card">
            <div @click="getDrawValuate1(15)">
              <p class="cardTitle">园区月度评价</p>
              <div class="cardCont">
                <img class="cardImg" src="../../../assets/imgs/icon_card015.png" />
                <p class="cardInfo">{{drawInfo.valuateCount}}</p>
              </div>
            </div>
          </el-card>
          <!-- 对应管家及评价 -->
          <el-card class="box-card">
            <div @click="getDrawStaffValuate1(16)">
              <p class="cardTitle">对应管家及评价</p>
              <div class="cardCont">
                <img class="cardImg" src="../../../assets/imgs/icon_card016.png" />
                <p class="cardInfo">{{drawInfo.staffValuateCount}}</p>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </el-card>
    <!-- 报事&投诉&居家服务 -->
    <el-card v-if="formNum==1||formNum==2||formNum==11" style="margin-top: 20px;">
      <el-form :inline="true">
        <!-- 时间 -->
        <el-form-item>
          <el-date-picker v-model="formData1.datevalues" type="daterange" :range-separator="$t('lang.lab_to')"
            :start-placeholder="$t('lang.lab_startDate')" :end-placeholder="$t('lang.lab_endDate')"
            value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <!-- 报事分类一级 -->
        <el-form-item>
          <el-select v-model="formData1.maintainTypeId1">
            <el-option key label="报事类型" value=""></el-option>
            <el-option v-for="(item,index) in formData1.firstLevellist" :key="index" :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 工单状态-->
        <el-form-item>
          <el-select v-model="formData1.state">
            <el-option key label="工单状态" value=""></el-option>
            <el-option v-for="(item,index) in formData1.statelist" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 工单id-->
        <el-form-item>
          <el-input v-model="formData1.maintainId" placeholder="工单ID"></el-input>
        </el-form-item>
        <el-button v-if="formNum==1" type="primary" @click="getDrawMaintains(1)">{{$t('lang.btn_search')}}</el-button>
        <el-button v-if="formNum==2" type="primary" @click="getDrawMaintains(2)">{{$t('lang.btn_search')}}</el-button>
        <el-button v-if="formNum==11" type="primary" @click="getDrawMaintainPrice(11)">{{$t('lang.btn_search')}}
        </el-button>
      </el-form>
      <el-table :data="formNum==1||formNum==2?tableData1:tableData11" class="wid100"
        :row-class-name="tableRowClassName">
        <!-- 序号 -->
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_index')" width="55px">
        </el-table-column>
        <!-- id -->
        <el-table-column prop="id" :label="$t('lang.lab_AdverId')" width="150px">
        </el-table-column>
        <!-- 报事用户 -->
        <el-table-column :label="$t('lang.lab_paperusername')" width="200px">
          <template slot-scope="scope" v-if="scope.row.user">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.user.nickName&&scope.row.user.nickName.length> 20" :disabled="false">
              <div slot="content">
                <span>{{ scope.row.user.nickName }}</span>
              </div>
              <div>
                {{ scope.row.user.nickName.substring(0, 10) | valueIsNull }}
                <span v-if="scope.row.user.nickName.length>10">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.user.nickName | valueIsNull }}</div>
            </el-tooltip>
          </template>
          <template slot-scope="scope" v-else>
            <el-tooltip placement="top" effect="light" v-if="scope.row.userName&&scope.row.userName.length> 10"
              :disabled="false">
              <div slot="content">
                <span>{{ scope.row.userName }}</span>
              </div>
              <div>
                {{ scope.row.userName.substring(0, 10) | valueIsNull }}
                <span v-if="scope.row.userName.length>10">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.userName | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 小区 -->
        <el-table-column :label="$t('lang.lab_papergarden')" width="150px">
          <template slot-scope="scope">{{ scope.row.garden.name}}</template>
        </el-table-column>
        <!-- 楼号 -->
        <el-table-column :label="$t('lang.lab_paperhouse')" width="100px">
          <template slot-scope="scope" v-if="scope&&scope.row.garden.grids">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.garden.grids.houseName&&scope.row.garden.grids.houseName.length> 5" :disabled="false">
              <div slot="content">
                <span>{{ scope.row.garden.grids.houseName }}</span>
              </div>
              <div>
                {{ scope.row.garden.grids.houseName.substring(0, 5) | valueIsNull }}
                <span v-if="scope.row.garden.grids.houseName.length>5">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.garden.grids.houseName | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 单元号 -->
        <el-table-column :label="$t('lang.lab_paperunit')" width="100px">
          <template slot-scope="scope" v-if="scope&&scope.row.garden.grids">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.garden.grids.unitName&&scope.row.garden.grids.unitName.length> 5" :disabled="false">
              <div slot="content">
                <span>{{ scope.row.garden.grids.unitName }}</span>
              </div>
              <div>
                {{ scope.row.garden.grids.unitName.substring(0, 5) | valueIsNull }}
                <span v-if="scope.row.garden.grids.unitName.length>5">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.garden.grids.unitName | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 房间号 -->
        <el-table-column :label="$t('lang.lab_paperroom')" width="100px">
          <template slot-scope="scope" v-if="scope&&scope.row.garden.grids">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.garden.grids.roomName&&scope.row.garden.grids.roomName.length> 5" :disabled="false">
              <div slot="content">
                <span>{{scope.row.garden.grids.roomName }}</span>
              </div>
              <div>
                {{ scope.row.garden.grids.roomName.substring(0, 5) | valueIsNull }}
                <span v-if="scope.row.garden.grids.roomName.length>5">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.garden.grids.roomName | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 报事时间 -->
        <el-table-column :label="$t('lang.lab_papertime')" width="200px" prop="createTime" sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.isOvertime === 1" class="red">{{scope.row.createTime | time}}</span>
            <span v-else>{{scope.row.createTime | time}}</span>
          </template>
        </el-table-column>
        <!-- 报事类别 -->
        <el-table-column prop="result" label="报事类别" width="150px">
          <template slot-scope="scope">
            <span v-if="scope.row.complainFlag === 0">报事</span>
            <span v-if="scope.row.complainFlag === 1">咨询</span>
            <span v-if="scope.row.complainFlag === 2">投诉</span>
            <span v-if="scope.row.complainFlag === 3">表扬</span>
          </template>
        </el-table-column>
        <!-- 报事类型 -->
        <el-table-column :label="$t('lang.lab_papertypes')" width="150px">
          <template slot-scope="scope" v-if="scope&&scope.row.maintainType1">{{scope.row.maintainType1.name}}</template>
        </el-table-column>
        <!-- 内容 -->
        <el-table-column :label="$t('lang.lab_papercontent')" prop="content" width="250px">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.content&&scope.row.content.length> require('@/config/enum').tableDatamaxlength10"
              :disabled="false">
              <div slot="content">
                <span>{{ scope.row.content }}</span>
              </div>
              <div class="conctentstyle">
                {{ scope.row.content.substring(0, require('@/config/enum').tableDatamaxlength10) | valueIsNull }}
                <span v-if="scope.row.content.length>require('@/config/enum').tableDatamaxlength10">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div class="conctentstyle">{{ scope.row.content | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 工单状态 -->
        <el-table-column sortable prop="state" width="120px" :label="$t('lang.lab_paperestate')">
          <template slot-scope="scope">
            <!-- 0: 报事状态 -->
            <span v-if="scope.row.state === 0">{{$t('lang.lab_paperereportingstate')}}</span>
            <!-- 1: 待确认 -->
            <span v-if="scope.row.state === 1" class="red">{{$t('lang.lab_papereconfirmed')}}</span>
            <!-- 2: 处理中 -->
            <span v-if="scope.row.state === 2" class="blue">{{$t('lang.lab_paperesolved')}}</span>
            <!-- 3: 已完成 -->
            <span v-if="scope.row.state === 3">{{$t('lang.lab_paperefinsh')}}</span>
            <!-- 4: 已评价 -->
            <span v-if="scope.row.state === 4 && scope.row.isFollow === 2"
              class="green">{{$t('lang.lab_paperealreadyevaluated')}}</span>
            <!-- 4: 已评价 -->
            <span
              v-if="scope.row.state === 4 && scope.row.isFollow != 2">{{$t('lang.lab_paperealreadyevaluated')}}</span>
            <!-- 5: 正常关闭 -->
            <span v-if="scope.row.state === 5">{{$t('lang.lab_paperecloses')}}</span>
            <!-- 6: 非正常关闭 -->
            <span v-if="scope.row.state === 6">{{$t('lang.lab_paperenoclose')}}</span>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column align="center" :label="$t('lang.lab_operation')" prop="operation" fixed="right" :width="180">
          <template slot-scope="scope" align="center">
            <el-button class="operation" @click="maintainsDetail(scope.row.id)">
              {{$t('lang.btn_detail')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!-- 投诉 -->
    <!-- <el-card v-if="formNum==2" style="margin-top: 20px;">
      22222222
    </el-card> -->
    <!-- 业主标签 -->
    <el-card v-if="formNum==3" style="margin-top: 20px;padding: 20px;">
      <el-tag v-for="item in tableData3" :key="item.udName" type="" effect="dark"
        style="margin-right:20px;margin-bottom:20px;height:50px;line-height:50px;font-size:18px;">
        {{ item.udName }}
      </el-tag>
    </el-card>
    <!-- 业主档案 -->
    <el-card v-if="formNum==4" style="margin-top: 20px;">
      <el-table :data="tableData4" :row-class-name="tableRowClassName">
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_index')" width="55px">
        </el-table-column>
        <el-table-column :label="$t('lang.lab_preHouseholdName')">
          <template slot-scope="scope">{{ scope.row.name}}</template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_buildingnum')">
          <template slot-scope="scope">{{ scope.row.houseName}}</template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_unitnum')">
          <template slot-scope="scope">{{ scope.row.unitName}}</template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_roomnum')">
          <template slot-scope="scope">{{ scope.row.roomName}}</template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_preHouseholdPhone')">
          <template slot-scope="scope">{{ scope.row.mobile}}</template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_preHouseholdID')">
          <template slot-scope="scope">{{ scope.row.idNo}}</template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_preHouseholdArea')">
          <template slot-scope="scope">{{ scope.row.buildArea}}</template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_housekeeper')" width="200">
          <template slot-scope="scope">{{ scope.row.staffName}}</template>
        </el-table-column>
        <el-table-column fixed="right" prop="opration" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="getDrawFilesDetail(scope.row)">档案信息</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!-- 变更信息记录 -->
    <el-card v-if="formNum==5" style="margin-top: 20px;">
      <el-table :data="tableData5" :row-class-name="tableRowClassName">
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_index')" width="55px">
        </el-table-column>
        <el-table-column label="变更项">
          <template slot-scope="scope">{{ scope.row.Col}}</template>
        </el-table-column>
        <el-table-column label="变更前">
          <template slot-scope="scope">{{ scope.row.OldValue}}</template>
        </el-table-column>
        <el-table-column label="变更后">
          <template slot-scope="scope">{{ scope.row.NewValue}}</template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="变更时间">
          <template slot-scope="scope">
            <span>{{scope.row.CreateTime | time}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!--业主门禁记录 -->
    <el-card v-if="formNum==6" style="margin-top: 20px;">
      <el-table :data="tableData6" :row-class-name="tableRowClassName">
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_index')" width="55px">
        </el-table-column>
        <el-table-column label="门禁名称">
          <template slot-scope="scope">{{ scope.row.doorName}}</template>
        </el-table-column>
        <el-table-column label="门禁mac地址">
          <template slot-scope="scope">{{ scope.row.doorMacName}}</template>
        </el-table-column>
        <el-table-column label="设备系统">
          <template slot-scope="scope">{{ scope.row.type}}</template>
        </el-table-column>
        <el-table-column prop="result" label="开门结果">
          <template slot-scope="scope">
            <span v-if="scope.row.result === 1">成功</span>
            <span v-if="scope.row.result === 2">失败</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="开门时间">
          <template slot-scope="scope">
            <span>{{scope.row.createTime | time}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!--业主乘梯记录 -->
    <el-card v-if="formNum==7" style="margin-top: 20px;">
      <el-table :data="tableData7" :row-class-name="tableRowClassName">
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_index')" width="55px">
        </el-table-column>
        <el-table-column label="电梯名称">
          <template slot-scope="scope">{{ scope.row.name}}</template>
        </el-table-column>
        <el-table-column label="电梯mac地址">
          <template slot-scope="scope">{{ scope.row.macName}}</template>
        </el-table-column>
        <el-table-column label="设备系统">
          <template slot-scope="scope">{{ scope.row.type}}</template>
        </el-table-column>
        <el-table-column prop="result" label="乘梯结果">
          <template slot-scope="scope">
            <span v-if="scope.row.result === 1">成功</span>
            <span v-if="scope.row.result === 2">失败</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="乘梯时间">
          <template slot-scope="scope">
            <span>{{scope.row.createTime | time}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!--业主缴费记录 -->
    <el-card v-if="formNum==8" style="margin-top: 20px;">
      <el-table :data="tableData8" :row-class-name="tableRowClassName">
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_index')" width="55px">
        </el-table-column>
        <el-table-column label="费用ID">
          <template slot-scope="scope">{{ scope.row.detail_id}}</template>
        </el-table-column>
        <el-table-column label="费用名称">
          <template slot-scope="scope">
            <span v-if="scope.row.fee_type_cd == '888800010001'">物业费</span>
            <span v-if="scope.row.fee_type_cd == '888800010009'">车位费</span>
          </template>
        </el-table-column>
        <el-table-column label="缴费金额">
          <template slot-scope="scope">{{ scope.row.received_amount}}</template>
        </el-table-column>
        <el-table-column label="收据单号">
          <template slot-scope="scope">{{ scope.row.receipt_number}}</template>
        </el-table-column>
        <el-table-column label="房间信息">
          <template slot-scope="scope">{{ scope.row.house_name}}-{{ scope.row.unit_name}}-{{ scope.row.room_name}}</template>
        </el-table-column>
        <el-table-column prop="create_time" label="缴费时间">
          <template slot-scope="scope">
            <span>{{scope.row.create_time | time}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!--业主车位信息 -->
    <el-card v-if="formNum==9" style="margin-top: 20px;">
      <el-table :data="tableData9" :row-class-name="tableRowClassName">
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_index')" width="55px">
        </el-table-column>
        <el-table-column label="车位数量">
          <template slot-scope="scope">{{ scope.row.carPlaceCount}}</template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!--业主车辆信息 -->
    <el-card v-if="formNum==10" style="margin-top: 20px;">
      <el-table :data="tableData10" :row-class-name="tableRowClassName">
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_index')" width="55px">
        </el-table-column>
        <el-table-column label="车牌号码">
          <template slot-scope="scope">{{ scope.row.CarNum}}</template>
        </el-table-column>
        <el-table-column prop="CarState" label="车辆状态">
          <template slot-scope="scope">
            <span v-if="scope.row.CarState == 1">正常</span>
            <span v-if="scope.row.CarState == 0">注销</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!--商城消费 -->
    <el-card v-if="formNum==12" style="margin-top: 20px;">
      <el-table :data="tableData12" :row-class-name="tableRowClassName">
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_index')" width="55px">
        </el-table-column>
        <el-table-column label="订单ID">
          <template slot-scope="scope">{{ scope.row.orderId}}</template>
        </el-table-column>
        <el-table-column label="用户昵称">
          <template slot-scope="scope">{{ scope.row.nickName}}</template>
        </el-table-column>
        <el-table-column label="联系电话">
          <template slot-scope="scope">{{ scope.row.cellphone}}</template>
        </el-table-column>
        <el-table-column label="消费金额">
          <template slot-scope="scope">{{ scope.row.totalPrice}}</template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!--邻里邦发帖 -->
    <el-card v-if="formNum==13" style="margin-top: 20px;">
      <el-table :data="tableData13" :row-class-name="tableRowClassName">
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_index')" width="55px">
        </el-table-column>
        <el-table-column label="园区">
          <template slot-scope="scope">{{ scope.row.gardenName}}</template>
        </el-table-column>
        <el-table-column label="帖子标题">
          <template slot-scope="scope">{{ scope.row.title}}</template>
        </el-table-column>
        <el-table-column label="帖子内容" prop="content" width="350px">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.content&&scope.row.content.length> require('@/config/enum').tableDatamaxlength15"
              :disabled="false">
              <div slot="content">
                <span>{{ scope.row.content }}</span>
              </div>
              <div class="conctentstyle">
                {{ scope.row.content.substring(0, require('@/config/enum').tableDatamaxlength15) | valueIsNull }}
                <span v-if="scope.row.content.length>require('@/config/enum').tableDatamaxlength15">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div class="conctentstyle">{{ scope.row.content | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="帖子状态">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 1">未审核</span>
            <span v-if="scope.row.state == 2">审核通过</span>
            <span v-if="scope.row.state == 3">审核不通过</span>
          </template>
        </el-table-column>
        <el-table-column label="帖子类型">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">左邻右里</span>
            <span v-if="scope.row.type === 2">闲余集市</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="发帖时间">
          <template slot-scope="scope">
            <span>{{scope.row.createTime | time}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!--格林房屋信息 -->
    <el-card v-if="formNum==14" style="margin-top: 20px;">
      <el-table :data="tableData14" :row-class-name="tableRowClassName">
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_index')" width="55px">
        </el-table-column>
        <el-table-column label="园区">
          <template slot-scope="scope">{{ scope.row.gardenName}}</template>
        </el-table-column>
        <el-table-column label="楼号">
          <template slot-scope="scope">{{ scope.row.house}}</template>
        </el-table-column>
        <el-table-column label="单元号">
          <template slot-scope="scope">{{ scope.row.unit}}</template>
        </el-table-column>
        <el-table-column label="房间号">
          <template slot-scope="scope">{{ scope.row.room}}</template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!--园区月度评价 -->
    <el-card v-if="formNum==15" style="margin-top: 20px;">
      <el-table :data="tableData15" :row-class-name="tableRowClassName">
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_index')" width="55px">
        </el-table-column>
        <el-table-column label="园区">
          <template slot-scope="scope">{{ scope.row.gardenName}}</template>
        </el-table-column>
        <el-table-column prop="evaluate" label="评价类型">
          <template slot-scope="scope">
            <span v-if="scope.row.evaluate == 0">未评价</span>
            <span v-if="scope.row.evaluate == 1">好评</span>
            <span v-if="scope.row.evaluate == 2">差评</span>
          </template>
        </el-table-column>
        <el-table-column label="文字评价">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.evaluateInfo&&scope.row.evaluateInfo.length> require('@/config/enum').tableDatamaxlength10"
              :disabled="false">
              <div slot="evaluateInfo">
                <span>{{ scope.row.evaluateInfo }}</span>
              </div>
              <div class="conctentstyle">
                {{ scope.row.evaluateInfo.substring(0, require('@/config/enum').tableDatamaxlength10) | valueIsNull }}
                <span v-if="scope.row.evaluateInfo.length>require('@/config/enum').tableDatamaxlength10">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div class="conctentstyle">{{ scope.row.evaluateInfo | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="评语评价">
          <template slot-scope="scope">{{ scope.row.evaluateRemark}}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="评价时间">
          <template slot-scope="scope">
            <span>{{scope.row.createTime | time}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!--对应管家及评价 -->
    <el-card v-if="formNum==16" style="margin-top: 20px;">
      <el-table :data="tableData16" :row-class-name="tableRowClassName">
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_index')" width="55px">
        </el-table-column>
        <el-table-column label="园区">
          <template slot-scope="scope">{{ scope.row.gardenName}}</template>
        </el-table-column>
        <el-table-column label="管家姓名">
          <template slot-scope="scope">{{ scope.row.staffName}}</template>
        </el-table-column>
        <el-table-column prop="star" label="评价等级">
          <template slot-scope="scope">
            <span v-if="scope.row.star == 1">
              <i class="el-icon-star-on c-00b1c3"></i>
              <i class="el-icon-star-on"></i>
              <i class="el-icon-star-on"></i>
              <i class="el-icon-star-on"></i>
              <i class="el-icon-star-on"></i>
            </span>
            <span v-if="scope.row.star == 2">
              <i class="el-icon-star-on c-00b1c3"></i>
              <i class="el-icon-star-on c-00b1c3"></i>
              <i class="el-icon-star-on"></i>
              <i class="el-icon-star-on"></i>
              <i class="el-icon-star-on"></i>
            </span>
            <span v-if="scope.row.star == 3">
              <i class="el-icon-star-on c-00b1c3"></i>
              <i class="el-icon-star-on c-00b1c3"></i>
              <i class="el-icon-star-on c-00b1c3"></i>
              <i class="el-icon-star-on"></i>
              <i class="el-icon-star-on"></i>
            </span>
            <span v-if="scope.row.star == 4">
              <i class="el-icon-star-on c-00b1c3"></i>
              <i class="el-icon-star-on c-00b1c3"></i>
              <i class="el-icon-star-on c-00b1c3"></i>
              <i class="el-icon-star-on c-00b1c3"></i>
              <i class="el-icon-star-on"></i>
            </span>
            <span v-if="scope.row.star == 5">
              <i class="el-icon-star-on c-00b1c3"></i>
              <i class="el-icon-star-on c-00b1c3"></i>
              <i class="el-icon-star-on c-00b1c3"></i>
              <i class="el-icon-star-on c-00b1c3"></i>
              <i class="el-icon-star-on c-00b1c3"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="评价内容">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.info&&scope.row.info.length> require('@/config/enum').tableDatamaxlength10"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.info }}
                </span>
              </div>
              <div>
                {{ scope.row.info.substring(0, require('@/config/enum').tableDatamaxlength10) | valueIsNull }}
                <span
                  v-if="scope.row.info.length>require('@/config/enum').tableDatamaxlength10"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.info | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="评价时间">
          <template slot-scope="scope">
            <span>{{scope.row.createTime | time}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!--代客报事 -->
    <el-card v-if="formNum==17" style="margin-top: 20px;">
      <el-table :data="tableData17" :row-class-name="tableRowClassName">
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_index')" width="55px">
        </el-table-column>
        <el-table-column label="园区">
          <template>{{row.garden.name}}</template>
        </el-table-column>
        <el-table-column label="报事ID">
          <template slot-scope="scope">{{ scope.row.Id}}</template>
        </el-table-column>
        <el-table-column label="报事内容">
          <!-- <template slot-scope="scope">{{ scope.row.Content}}</template> -->
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.Content&&scope.row.Content.length> require('@/config/enum').tableDatamaxlength25"
              :disabled="false">
              <div slot="content">
                <span>{{ scope.row.Content }}</span>
              </div>
              <div class="conctentstyle">
                {{ scope.row.Content.substring(0, require('@/config/enum').tableDatamaxlength25) | valueIsNull }}
                <span v-if="scope.row.Content.length>require('@/config/enum').tableDatamaxlength25">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div class="conctentstyle">{{ scope.row.Content | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column align="center" :label="$t('lang.lab_operation')" prop="operation" fixed="right" :width="180">
          <template slot-scope="scope" align="center">
            <el-button class="operation" @click="maintainsDetail(scope.row.Id)">
              {{$t('lang.btn_detail')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!--沟通记录 -->
    <el-card v-if="formNum==18" style="margin-top: 20px;">
      <el-table :data="tableData18" :row-class-name="tableRowClassName">
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_index')" width="55px">
        </el-table-column>
        <el-table-column label="园区">
          <template>{{row.garden.name}}</template>
        </el-table-column>
        <el-table-column label="沟通内容">
          <template slot-scope="scope">{{ scope.row.Remark}}</template>
        </el-table-column>
        <el-table-column label="图片">
          <template slot-scope="scope">
            <viewer :images="scope.row.Url">
                <img :src="scope.row.Url" class="img" />
              </viewer>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!-- 业主档案弹窗 -->
    <el-dialog title="业主档案" :visible.sync="dialogVisible" width="60%">
      <el-tabs v-model="activeName" @tab-click="handleClick" v-if="hasDrawFilesDetail">
        <el-tab-pane label="入住文件" name="1" v-if="drawFilesDetail.urls3!=''">
          <el-image v-for="(item,index) in drawFilesDetail.urls3" :src="item.split('|')[0]" :preview-src-list="item.split('|').slice(0, 1)" fit="fill" :key=index
            style="width: 200px; height: 200px; margin-top: 50px; margin-right: 20px;"></el-image>
        </el-tab-pane>
        <el-tab-pane label="装修管理文件" name="2" v-if="drawFilesDetail.urls4!=''">
          <el-image v-for="(item,index) in drawFilesDetail.urls4" :src="item.split('|')[0]" :preview-src-list="item.split('|').slice(0, 1)" fit="fill" :key=index
            style="width: 200px; height: 200px; margin-top: 50px; margin-right: 20px;"></el-image>
        </el-tab-pane>
        <el-tab-pane label="车位管理文件" name="3" v-if="drawFilesDetail.urls5!=''">
          <el-image v-for="(item,index) in drawFilesDetail.urls5" :src="item.split('|')[0]" :preview-src-list="item.split('|').slice(0, 1)" fit="fill" :key=index
            style="width: 200px; height: 200px; margin-top: 50px; margin-right: 20px;"></el-image>
        </el-tab-pane>
        <el-tab-pane label="保险理赔文件" name="4" v-if="drawFilesDetail.urls6!=''">
          <el-image v-for="(item,index) in drawFilesDetail.urls6" :src="item.split('|')[0]" :preview-src-list="item.split('|').slice(0, 1)" fit="fill" :key=index
            style="width: 200px; height: 200px; margin-top: 50px; margin-right: 20px;"></el-image>
        </el-tab-pane>
        <el-tab-pane label="法律诉讼文件" name="5" v-if="drawFilesDetail.urls7!=''">
          <el-image v-for="(item,index) in drawFilesDetail.urls7" :src="item.split('|')[0]" :preview-src-list="item.split('|').slice(0, 1)" fit="fill" :key=index
            style="width: 200px; height: 200px; margin-top: 50px; margin-right: 20px;"></el-image>
        </el-tab-pane>
        <el-tab-pane label="二手房交易文件" name="6" v-if="drawFilesDetail.urls8!=''">
          <el-image v-for="(item,index) in drawFilesDetail.urls8" :src="item.split('|')[0]" :preview-src-list="item.split('|').slice(0, 1)" fit="fill" :key=index
            style="width: 200px; height: 200px; margin-top: 50px; margin-right: 20px;"></el-image>
        </el-tab-pane>
        <el-tab-pane label="返修管理文件" name="7" v-if="drawFilesDetail.urls9!=''">
          <el-image v-for="(item,index) in drawFilesDetail.urls9" :src="item.split('|')[0]" :preview-src-list="item.split('|').slice(0, 1)" fit="fill" :key=index
            style="width: 200px; height: 200px; margin-top: 50px; margin-right: 20px;"></el-image>
        </el-tab-pane>
        <el-tab-pane label="其它附件" name="8" v-if="drawFilesDetail.urls!=''">
          <el-image v-for="(item,index) in drawFilesDetail.urls" :src="item.split('|')[0]" :preview-src-list="item.split('|').slice(0, 1)" fit="fill" :key=index
            style="width: 200px; height: 200px; margin-top: 50px; margin-right: 20px;"></el-image>
        </el-tab-pane>
      </el-tabs>
      <span class="noDrawFilesDetail" v-else>暂无数据</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:appHouseholdPortrait
   *@Description:app业主画像
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2022-03-23
   */
  export default {
    data() {
      return {
        tabNum: 1, // 按业主  按房间 
        formNum: 1, // 根据点击汇总，切换下方列表展示
        drawInfo: {}, // 页面汇总数据
        drawRoomInfo: {}, // 房间报事数据
        pageCount: 1, // 总数
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        dialogVisible: false, // 业主档案弹窗状态
        drawFilesDetail: {}, // 业主档案详情数据
        hasDrawFilesDetail: true, // 是否有业主档案文件
        activeName: '1',
        tableData1: [], // 报事列表数据
        tableData2: [], // 投诉列表数据
        tableData3: [], // 业主标签列表数据
        tableData4: [], // 业主档案列表数据
        tableData5: [], // 业主变更信息记录
        tableData6: [], // 业主门禁记录
        tableData7: [], // 业主梯控记录
        tableData8: [], // 业主缴费记录
        tableData9: [], // 业主车位记录
        tableData10: [], // 业主车辆记录
        tableData11: [], // 居家服务工单列表数据
        tableData12: [], // 商城消费金额，积分列表数据
        tableData13: [], // 邻里邦发帖列表数据
        tableData14: [], // 格林房屋信息列表数据
        tableData15: [], // 园区月度评价列表数据
        tableData16: [], // 管家评价列表数据
        tableData17: [], // 代客报事列表数据
        tableData18: [], // 管家日志列表数据
        formData1: {
          datevalues: '', // 报事时间筛选
          maintainTypeId1: '', // 一级分类绑定id
          firstLevellist: [], // 一级分类list
          typeleval: 1, // 级别接口区分字段
          state: '', // 工单状态绑定值
          statelist: this.$i18n.t('lang.NewspaperInfoList.statelist'), // 工单状态list
          maintainId: '', // 工单id
        },
      }
    },
    activated() {

    },
    created() {
      // 初始化接收数据
      if (this.$route.query.row.id) {
        this.row = this.$route.query.row
        localStorage.setItem('row', JSON.stringify(this.$route.query.row))
      } else {
        let row = JSON.parse(localStorage.getItem('row'))
        if (row) {
          this.row = row
        } else {
          this.row = ''
        }
      }
      console.log(this.row)
      this.getDrawUserAll()
      this.getDrawRoomAll()
      this.maintainTypes()
      this.getDrawMaintains1(1)
      this.getDrawUser1(3)
    },
    watch: {

    },
    methods: {
      // 页面汇总展示
      getDrawUserAll() {
        let loading = this.$loading()
        // this.$get(`/drawUserAll/?userId=2380&gardenId=37`).then(
        this.$get(`/drawUserAll/?userId=${this.row.id}&gardenId=${this.row.garden.id}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              if (res.drawInfo) {
                this.drawInfo = res.drawInfo
              } else {
                this.$set(this.drawInfo, 'complain', 0)
                this.$set(this.drawInfo, 'userDrawCount', 0)
                this.$set(this.drawInfo, 'fjCount', 0)
                this.$set(this.drawInfo, 'rcCount', 0)
                this.$set(this.drawInfo, 'doorCount', 0)
                this.$set(this.drawInfo, 'liftCount', 0)
                this.$set(this.drawInfo, 'jfAmount', 0)
                this.$set(this.drawInfo, 'carPlaceCount', 0)
                this.$set(this.drawInfo, 'carCount', 0)
                this.$set(this.drawInfo, 'price', 0)
                this.$set(this.drawInfo, 'sklOrderPrice', 0)
                this.$set(this.drawInfo, 'topicCount', 0)
                this.$set(this.drawInfo, 'valetCount', 0)
                this.$set(this.drawInfo, 'drawImageCount', 0)
                this.$set(this.drawInfo, 'roomCount', 0)
                this.$set(this.drawInfo, 'valuateCount', 0)
                this.$set(this.drawInfo, 'staffValuateCount', 0)
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 页面报事总数（根据房间号查询）
      getDrawRoomAll() {
        let loading = this.$loading()
        this.$get(`/drawRoomAll/?roomId=${this.row.garden.grids.roomId}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              if (res.drawRoomInfo) {
                this.drawRoomInfo = res.drawRoomInfo
              } else {
                this.$set(this.drawRoomInfo, 'maintainCount', 0)
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 页面报事列表
      getDrawMaintains(n) {
        var complainFlag
        if (n == 1) {
          complainFlag = 0
        } else if (n == 2) {
          complainFlag = 2
        }
        var start = ''
        var end = ''
        if (this.formData1.datevalues != null) {
          if (this.formData1.datevalues.length > 0) {
            start = this.formData1.datevalues[0]
            end = this.formData1.datevalues[1]
          }
        }
        console.log(this.formData1)
        let loading = this.$loading()
        // this.$get(
        //   `/getDrawMaintains/?userId=2380&gardenId=37&years=1&complainFlag=` + complainFlag +
        //   `&pageNo=${this.pageNo}&pageSize=${this.pageSize}&start=` + start + `&end=` + end +
        //   `&maintainTypeId1=${this.formData1.maintainTypeId1}&state=${this.formData1.state}&maintainId=${this.formData1.maintainId}`
        // ).then(
        this.$get(
          `/getDrawMaintainsRoomId/?roomId=${this.row.garden.grids.roomId}&years=1&complainFlag=` +
          complainFlag +
          `&pageNo=${this.pageNo}&pageSize=${this.pageSize}&start=` + start + `&end=` + end +
          `&maintainTypeId1=${this.formData1.maintainTypeId1}&state=${this.formData1.state}&maintainId=${this.formData1.maintainId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData1 = res.list
              this.pageCount = res.pageCount == 0 ? 1 : res.pageCount
              console.log(123)
              console.log(this.tableData1)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 报事操作详情
      maintainsDetail(id) {
        this.$router.push({
          name: 'projectWideRepoInfoBackgroundDetail1',
          query: {
            id: id
          }
        })
      },
      // 报事服务分类list
      maintainTypes() {
        this.$get(
          `/maintainTypes?type=${this.formData1.typeleval}&pageSize=999&pageNo=${this.pageNo}&parentId=${this.row.garden.id}`
        ).then(
          res => {
            if (res && res.errCode === 0) {
              if (this.formData1.typeleval === 1) {
                this.formData1.firstLevellist = res.list
              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 获取业主标签列表
      getDrawUser(n) {
        let loading = this.$loading()
        // this.$get(`/drawUser/?userId=13971&gardenId=26&pageNo=${this.pageNo}&pageSize=${this.pageSize}`).then(
        this.$get(
          `/drawUser/?userId=${this.row.id}&gardenId=${this.row.garden.id}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              if (res.listDrawUserGarden.length == 0) {
                this.tableData3 = res.list
                this.$set(this.drawInfo, 'userDrawCount', res.list.length)
              } else {
                this.tableData3 = res.listDrawUserGarden
                this.$set(this.drawInfo, 'userDrawCount', res.listDrawUserGarden.length)
              }
              // this.pageCount = res.pageCount == 0 ? 1 : res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取业主档案列表
      getDrawFiles(n) {
        let loading = this.$loading()
        // this.$get(`/roomOwner/page?userId=2380&gardenId=5&pageNo=${this.pageNo}&pageSize=${this.pageSize}&fjType=0&fjName=`).then(
        this.$get(
            `/roomOwner/page?userId=${this.row.id}&gardenId=${this.row.garden.id}&pageNo=${this.pageNo}&pageSize=${this.pageSize}&fjType=0&fjName=`
            )
          .then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                console.log(res)
                this.tableData4 = res.list
                this.pageCount = res.pageCount == 0 ? 1 : res.pageCount
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
      },
      // 获取业主档案详情
      getDrawFilesDetail(row) {
        this.drawFilesDetail = {}
        this.dialogVisible = true
        console.log(row)
        this.drawFilesDetail = row
        this.hasDrawFilesDetail = true
        if (this.drawFilesDetail.urls3.length > 0) {
          this.activeName = '1'
          return false
        } else if (this.drawFilesDetail.urls4.length > 0) {
          this.activeName = '2'
          return false
        } else if (this.drawFilesDetail.urls5.length > 0) {
          this.activeName = '3'
          return false
        } else if (this.drawFilesDetail.urls6.length > 0) {
          this.activeName = '4'
          return false
        } else if (this.drawFilesDetail.urls7.length > 0) {
          this.activeName = '5'
          return false
        } else if (this.drawFilesDetail.urls8.length > 0) {
          this.activeName = '6'
          return false
        } else if (this.drawFilesDetail.urls9.length > 0) {
          this.activeName = '7'
          return false
        } else if (this.drawFilesDetail.urls.length > 0) {
          this.activeName = '8'
          return false
        } else {
          this.hasDrawFilesDetail = false
        }
      },
      // 获取变更信息记录列表
      getDrawRoomOwnerChange(n) {
        let loading = this.$loading()
        // this.$get(`/getDrawRoomOwnerChange/?userId=2239&gardenId=5&pageNo=${this.pageNo}&pageSize=${this.pageSize}`)
        //   .then(
        this.$get(
            `/getDrawRoomOwnerChange/?userId=${this.row.id}&gardenId=${this.row.garden.id}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
            )
          .then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                console.log(res)
                this.tableData5 = res.list
                this.pageCount = res.pageCount == 0 ? 1 : res.pageCount
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
      },
      // 获取业主门禁记录列表
      getDrawDoorDeviceRecord(n) {
        let loading = this.$loading()
        // this.$get(`/getDrawDoorDeviceRecord/?userId=2380&gardenId=24&pageNo=${this.pageNo}&pageSize=${this.pageSize}`)
        //   .then(
        this.$get(
            `/getDrawDoorDeviceRecord/?userId=${this.row.id}&gardenId=${this.row.garden.id}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
            )
          .then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                console.log(res)
                this.tableData6 = res.list
                this.pageCount = res.pageCount == 0 ? 1 : res.pageCount
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
      },
      // 获取业主乘梯记录列表
      getDrawLiftRecord(n) {
        let loading = this.$loading()
        // this.$get(`/getDrawLiftRecord/?userId=25711&gardenId=24&pageNo=${this.pageNo}&pageSize=${this.pageSize}`)
        //   .then(
        this.$get(
            `/getDrawLiftRecord/?userId=${this.row.id}&gardenId=${this.row.garden.id}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
            )
          .then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                console.log(res)
                this.tableData7 = res.list
                this.pageCount = res.pageCount == 0 ? 1 : res.pageCount
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
      },
      // 获取业主缴费记录列表
      getDrawPayFee(n) {
        let loading = this.$loading()
        // this.$get(`/getDrawPayFee/?userId=1751&gardenId=24&pageNo=${this.pageNo}&pageSize=${this.pageSize}`)
        //   .then(
        this.$get(
            `/getDrawPayFee/?userId=${this.row.id}&gardenId=${this.row.garden.id}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
            )
          .then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                console.log(res)
                this.tableData8 = res.list
                this.pageCount = res.pageCount == 0 ? 1 : res.pageCount
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
      },
      // 获取业主车位信息
      getDrawCarPlaceCount(n) {
        let loading = this.$loading()
        // this.$get(`/getDrawCarPlaceCount/?userId=2239&gardenId=5&pageNo=${this.pageNo}&pageSize=${this.pageSize}`)
        //   .then(
        this.$get(
            `/getDrawCarPlaceCount/?userId=${this.row.id}&gardenId=${this.row.garden.id}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
            )
          .then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                console.log(res)
                this.tableData9 = res.list
                this.pageCount = res.pageCount == 0 ? 1 : res.pageCount
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
      },
      // 获取业主车辆信息
      getDrawCarNum(n) {
        let loading = this.$loading()
        // this.$get(`/getDrawCarNum/?userId=2239&gardenId=5&pageNo=${this.pageNo}&pageSize=${this.pageSize}`)
        //   .then(
        this.$get(
            `/getDrawCarNum/?userId=${this.row.id}&gardenId=${this.row.garden.id}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
            )
          .then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                console.log(res)
                this.tableData10 = res.list
                this.pageCount = res.pageCount == 0 ? 1 : res.pageCount
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
      },
      // 获取居家服务工单列表
      getDrawMaintainPrice(n) {
        var start = ''
        var end = ''
        if (this.formData1.datevalues != null) {
          if (this.formData1.datevalues.length > 0) {
            start = this.formData1.datevalues[0]
            end = this.formData1.datevalues[1]
          }
        }
        console.log(this.formData1)
        let loading = this.$loading()
        // this.$get(
        //     `/getDrawMaintainPrice/?userId=227&gardenId=22&pageNo=${this.pageNo}&pageSize=${this.pageSize}&start=` +
        //     start + `&end=` + end +
        //     `&maintainTypeId1=${this.formData1.maintainTypeId1}&state=${this.formData1.state}&maintainId=${this.formData1.maintainId}`
        //   )
        //   .then(
        this.$get(
            `/getDrawMaintainPrice/?userId=${this.row.id}&gardenId=${this.row.garden.id}&pageNo=${this.pageNo}&pageSize=${this.pageSize}&start=` +
            start + `&end=` + end +
            `&maintainTypeId1=${this.formData1.maintainTypeId1}&state=${this.formData1.state}&maintainId=${this.formData1.maintainId}`
          )
          .then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                console.log(res)
                this.tableData11 = res.list
                this.pageCount = res.pageCount == 0 ? 1 : res.pageCount
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
      },
      // 获取商城消费列表
      getDrawSklOrder(n) {
        let loading = this.$loading()
        // this.$get(`/getDrawSklOrder/?userId=1905&gardenId=5&pageNo=${this.pageNo}&pageSize=${this.pageSize}`)
        //   .then(
        this.$get(
            `/getDrawSklOrder/?userId=${this.row.id}&gardenId=${this.row.garden.id}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
            )
          .then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                console.log(res)
                this.tableData12 = res.list
                this.pageCount = res.pageCount == 0 ? 1 : res.pageCount
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
      },
      // 获取邻里帮发帖列表
      getDrawTopic(n) {
        let loading = this.$loading()
        // this.$get(`/getDrawTopic/?userId=2258&gardenId=26&pageNo=${this.pageNo}&pageSize=${this.pageSize}`)
        //   .then(
        this.$get(
            `/getDrawTopic/?userId=${this.row.id}&gardenId=${this.row.garden.id}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
            )
          .then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                console.log(res)
                this.tableData13 = res.list
                this.pageCount = res.pageCount == 0 ? 1 : res.pageCount
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
      },
      // 获取格林房屋信息
      getDrawUserGarden(n) {
        let loading = this.$loading()
        // this.$get(`/getDrawUserGarden/?userId=4127&gardenId=24&pageNo=${this.pageNo}&pageSize=${this.pageSize}`)
        //   .then(
        this.$get(
            `/getDrawUserGarden/?userId=${this.row.id}&gardenId=${this.row.garden.id}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
            )
          .then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                console.log(res)
                this.tableData14 = res.list
                this.pageCount = res.pageCount == 0 ? 1 : res.pageCount
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
      },
      // 获取园区月度评价
      getDrawValuate(n) {
        let loading = this.$loading()
        // this.$get(`/getDrawValuate/?userId=1905&gardenId=24&pageNo=${this.pageNo}&pageSize=${this.pageSize}`)
        //   .then(
        this.$get(
            `/getDrawValuate/?userId=${this.row.id}&gardenId=${this.row.garden.id}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
            )
          .then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                console.log(res)
                this.tableData15 = res.list
                this.pageCount = res.pageCount == 0 ? 1 : res.pageCount
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
      },
      // 对应管家及评价
      getDrawStaffValuate(n) {
        let loading = this.$loading()
        // this.$get(`/getDrawStaffValuate/?userId=6688&gardenId=14&pageNo=${this.pageNo}&pageSize=${this.pageSize}`)
        //   .then(
        this.$get(
            `/getDrawStaffValuate/?userId=${this.row.id}&gardenId=${this.row.garden.id}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
            )
          .then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                console.log(res)
                this.tableData16 = res.list
                this.pageCount = res.pageCount == 0 ? 1 : res.pageCount
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
      },
      // 代客报事
      getDrawValet(n) {
        let loading = this.$loading()
        this.$get(
            `/getDrawValet/?userId=${this.row.id}&gardenId=${this.row.garden.id}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
            )
          .then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                console.log(res)
                this.tableData17 = res.list
                this.pageCount = res.pageCount == 0 ? 1 : res.pageCount
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
      },
      // 沟通记录
      getDrawImage(n) {
        let loading = this.$loading()
        this.$get(
            `/getDrawImage/?userId=${this.row.id}&gardenId=${this.row.garden.id}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
            )
          .then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                console.log(res)
                this.tableData18 = res.list
                this.pageCount = res.pageCount == 0 ? 1 : res.pageCount
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
      },
      // 切换卡片初始化
      initialize(n) {
        this.pageNo = 1
        this.pageSize = 10
        this.pageCount = 0
        this.formNum = n
      },
      // 返回APP住户管理
      jump() {
        this.$router.push({
          name: 'appHouseholdManageList'
        })
      },
      getDrawMaintains1(n) {
        // 清空共用模糊搜索字段
        this.formData1.datevalues = ''
        this.formData1.maintainTypeId1 = ''
        this.formData1.state = ''
        this.formData1.maintainId = ''
        this.initialize(n)
        this.getDrawMaintains(n)
      },
      getDrawUser1(n) {
        this.initialize(n)
        this.getDrawUser(n)
      },
      getDrawFiles1(n) {
        this.initialize(n)
        this.getDrawFiles(n)
      },
      getDrawRoomOwnerChange1(n) {
        this.initialize(n)
        this.getDrawRoomOwnerChange(n)
      },
      getDrawDoorDeviceRecord1(n) {
        this.initialize(n)
        this.getDrawDoorDeviceRecord(n)
      },
      getDrawLiftRecord1(n) {
        this.initialize(n)
        this.getDrawLiftRecord(n)
      },
      getDrawPayFee1(n) {
        this.initialize(n)
        this.getDrawPayFee(n)
      },
      getDrawCarPlaceCount1(n) {
        this.initialize(n)
        this.getDrawCarPlaceCount(n)
      },
      getDrawCarNum1(n) {
        this.initialize(n)
        this.getDrawCarNum(n)
      },
      getDrawMaintainPrice1(n) {
        // 清空共用模糊搜索字段
        this.formData1.datevalues = ''
        this.formData1.maintainTypeId1 = ''
        this.formData1.state = ''
        this.formData1.maintainId = ''
        this.initialize(n)
        this.getDrawMaintainPrice(n)
      },
      getDrawSklOrder1(n) {
        this.initialize(n)
        this.getDrawSklOrder(n)
      },
      getDrawTopic1(n) {
        this.initialize(n)
        this.getDrawTopic(n)
      },
      getDrawUserGarden1(n) {
        this.initialize(n)
        this.getDrawUserGarden(n)
      },
      getDrawValuate1(n) {
        this.initialize(n)
        this.getDrawValuate(n)
      },
      getDrawStaffValuate1(n) {
        this.initialize(n)
        this.getDrawStaffValuate(n)
      },
      getDrawValet1(n) {
        console.log(222222222)
        console.log(n)
        this.initialize(n)
        this.getDrawValet(n)
      },
      getDrawImage1(n) {
        console.log(11111111111)
        console.log(n)
        this.initialize(n)
        this.getDrawImage(n)
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        switch (this.formNum) {
          case 1:
            this.getDrawMaintains(this.formNum)
            break
          case 2:
            this.getDrawMaintains(this.formNum)
            break
          case 4:
            this.getDrawFiles(this.formNum)
            break
          case 5:
            this.getDrawRoomOwnerChange(this.formNum)
            break
          case 6:
            this.getDrawDoorDeviceRecord(this.formNum)
            break
          case 7:
            this.getDrawLiftRecord(this.formNum)
            break
          case 8:
            this.getDrawPayFee(this.formNum)
            break
          case 10:
            this.getDrawCarNum(this.formNum)
            break
          case 11:
            this.getDrawMaintains(this.formNum)
            break
          case 12:
            this.getDrawSklOrder(this.formNum)
            break
          case 13:
            this.getDrawTopic(this.formNum)
            break
          case 14:
            this.getDrawUserGarden(this.formNum)
            break
          case 15:
            this.getDrawValuate(this.formNum)
            break
          case 16:
            this.getDrawStaffValuate(this.formNum)
            break
          case 17:
            this.getDrawValet(this.formNum)
            break
          case 18:
            this.getDrawImage(this.formNum)
            break
        }
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        switch (this.formNum) {
          case 1:
            this.getDrawMaintains(this.formNum)
            break
          case 2:
            this.getDrawMaintains(this.formNum)
            break
          case 4:
            this.getDrawFiles(this.formNum)
            break
          case 5:
            this.getDrawRoomOwnerChange(this.formNum)
            break
          case 6:
            this.getDrawDoorDeviceRecord(this.formNum)
            break
          case 7:
            this.getDrawLiftRecord(this.formNum)
            break
          case 8:
            this.getDrawPayFee(this.formNum)
            break
          case 10:
            this.getDrawCarNum(this.formNum)
            break
          case 11:
            this.getDrawMaintains(this.formNum)
            break
          case 12:
            this.getDrawSklOrder(this.formNum)
            break
          case 13:
            this.getDrawTopic(this.formNum)
            break
          case 14:
            this.getDrawUserGarden(this.formNum)
            break
          case 15:
            this.getDrawValuate(this.formNum)
            break
          case 16:
            this.getDrawStaffValuate(this.formNum)
            break
          case 17:
            this.getDrawValet(this.formNum)
            break
          case 18:
            this.getDrawImage(this.formNum)
            break
        }
      },
      handleClick(tab, event) {
        console.log(tab, event)
      },
      getSmallIcon(number) {
        if (Number.isInteger(number)) {
          if (number.toString().length > 5) {
            return 'smallIcon'
          } else {
            return ''
          }
        } else {
          if (number.toString().length - 1 > 5) {
            return 'smallIcon'
          } else {
            return ''
          }
        }
      },
      getSmallFont(number) {
        if (Number.isInteger(number)) {
          if (number.toString().length > 5) {
            return 'smallFont'
          } else {
            return ''
          }
        } else {
          if (number.toString().length - 1 > 5) {
            return 'smallFont'
          } else {
            return ''
          }
        }
      },
    }
  }
</script>

<style lang='scss'>
  .appHouseholdPortrait {
    .el-dialog__body {
      padding: 0 10px 10px 10px !important;
      box-sizing: border-box;
    }

    .el-tabs__nav-wrap {
      width: 99% !important;
      max-width: 100% !important;
    }

    .el-tabs__nav-scroll {
      width: 100% !important;
    }

    .el-tabs__nav {
      display: flex;
      width: 100%;
      text-align: center;
    }

    .jump-btn {
      position: relative;
      min-width: 1000px;

      .tag1 {
        position: absolute;
        left: 10px;
        text-align: left;
      }

      .tag2 {
        position: absolute;
        left: 120px;
      }
    }

    .el-card {
      box-sizing: border-box;
      overflow: auto;
    }

    .cardList {
      // display: flex;
      // flex-wrap: wrap;
    }

    .lineBox1,
    .lineBox2,
    .lineBox3 {
      display: flex;
    }

    .box-card {
      width: 13vw;
      text-align: center;
      margin: 0 0px 20px 10px;
      min-width: 170px;
    }

    .cardTitle {
      font-size: 18px;
      font-weight: bold;
    }

    .cardCont {
      display: flex;
      align-items: center;
      font-size: 30px;
      font-weight: bold;
      margin: 10px 0;
      padding: 0 10px;
    }

    .cardImg {
      width: 3vw;
      height: 3vw;
    }
    .noImg{
      visibility: hidden;
    }

    .cardInfo {
      flex: 1;
      display: inline-block;
      margin-left: -3vw;
    }

    .lineBox1 .box-card {
      color: #ed8599 !important;
    }

    .lineBox2 .box-card {
      color: #00b1c3 !important;
    }

    .lineBox3 .box-card {
      color: #b4d049 !important;
    }

    .c-00b1c3 {
      color: #00b1c3;
    }

    .noDrawFilesDetail {
      font-size: 30px;
      text-align: center;
      width: 100%;
      display: block;
      margin-top: 50px;
      margin-bottom: 30px
    }

    .el-tabs {
      background-color: #fff !important;
    }

    .el-tabs__item {
      flex: 1;
    }

    .el-tabs__item.is-top:last-child {
      border-right: none !important;
    }

    .smallFont{
      font-size: 24px;
      margin-left: -2.5vw;
    }
    .smallIcon{
      width: 2.5vw;
      height: 2.5vw;
    }
    .img {
      width: 40px;
      height: 24px;
      border: 1px solid lightgray;
      border-radius: 5px;
      padding: 5px;
      margin-right: 20px;
    }
  }
</style>